import { render, staticRenderFns } from "./boardListStyle.vue?vue&type=template&id=e2cb6178&scoped=true&"
import script from "./boardListStyle.vue?vue&type=script&lang=js&"
export * from "./boardListStyle.vue?vue&type=script&lang=js&"
import style0 from "./boardListStyle.vue?vue&type=style&index=0&id=e2cb6178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cb6178",
  null
  
)

export default component.exports